// extracted by mini-css-extract-plugin
export var optionGrid = "_82-7";
export var optionList = "_82-6";
export var questionsBlock = "_82-9";
export var spacer = "_82-5";
export var stepCenteredContent = "_82-3";
export var stepInner = "_82-0";
export var stepInnerFullWidth = "_82-1";
export var stepInnerLockScroll = "_82-2";
export var stepTransitionFrame = "_82-4";
export var welcomeBlock = "_82-8";